import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, sessao, FLUXO, ST_LABEL, ST_COR } from '../api';
import { Icone } from '../Icones.jsx';

export default function Expedicao() {
  const u = sessao.usuario;
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [perda, setPerda] = useState(null); // { id, texto }
  const [fornecedores, setFornecedores] = useState([]);
  const [diasAtraso, setDiasAtraso] = useState(5);
  useEffect(() => { api('/config').then(c => setDiasAtraso(c.dias_atraso)).catch(() => {}); }, []);
  useEffect(() => { api('/fornecedores').then(setFornecedores).catch(() => {}); }, []);

  const salvarCaixa = async (id, caixa) => {
    try { await api(`/ordens/${id}/expedicao`, { method: 'PATCH', body: { caixa } }); carregar(); }
    catch (e) { setErro(e.message); }
  };
  const salvarPedido = async (id, numero_pedido) => {
    try { await api(`/ordens/${id}/expedicao`, { method: 'PATCH', body: { numero_pedido } }); carregar(); }
    catch (e) { setErro(e.message); }
  };
  const salvarFornecedor = async (id, fornecedor_id) => {
    try { await api(`/ordens/${id}/expedicao`, { method: 'PATCH', body: { fornecedor_id } }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  const registrarPerda = async () => {
    if (!perda?.texto?.trim()) return;
    try {
      await api(`/ordens/${perda.id}/perda`, { method: 'POST', body: { descricao: perda.texto } });
      setPerda(null); carregar();
    } catch (e) { setErro(e.message); }
  };

  const carregar = () => {
    setCarregando(true);
    api('/ordens').then(setLista).catch(e => setErro(e.message)).finally(() => setCarregando(false));
  };
  useEffect(() => { carregar(); }, []);

  const avancar = async id => {
    try {
      await api(`/ordens/${id}/status`, { method: 'PATCH' });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const abertas = lista.filter(o => o.status !== 'recebido_loja' && !o.cancelada);

  return (
    <div>
      <h2 style={{ marginBottom: 14 }}>Expedição · {abertas.length} em andamento</h2>
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
      {carregando && <div className="card">Carregando…</div>}

      <div className="grid">
        {abertas.map(o => {
          const idx = FLUXO.indexOf(o.status);
          const proximo = FLUXO[idx + 1];
          // A etapa final é exclusiva da loja de origem (admin como exceção)
          const podeClicar = proximo && (proximo !== 'recebido_loja'
            ? true
            : (u.perfil === 'admin' || u.loja_id === o.loja_id));
          return (
            <div key={o.id} className="card">
              <div className="row" style={{ justifyContent: 'space-between' }}>
                <div>
                  <Link to={`/ordens/${o.id}`} style={{ fontWeight: 800, fontSize: 15, color: 'inherit', textDecoration: 'none' }}>
                    OS {o.numero_os} · {o.cliente}
                  </Link>
                  <div style={{ fontSize: 12.5, color: 'var(--cinza)' }}>
                    {o.loja_nome} · Vend.: {o.vendedor || '—'} · {o.lente || 'lente não informada'}
                    {o.numero_pedido && <strong> · Pedido {o.numero_pedido}</strong>}
                    {o.caixa && <strong style={{ color: 'var(--verde)' }}> · Caixa {o.caixa}</strong>}
                    {o.dias >= diasAtraso && <strong style={{ color: 'var(--vermelho)' }}> · {o.dias} dias!</strong>}
                  </div>
                </div>
                <div className="row">
                  <input className="input" placeholder="Nº pedido" defaultValue={o.numero_pedido || ''}
                    title="Número do pedido no fornecedor/laboratório"
                    style={{ width: 100, fontSize: 12.5, padding: '5px 7px' }}
                    onBlur={e => e.target.value !== (o.numero_pedido || '') && salvarPedido(o.id, e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && e.target.blur()} />
                  <input className="input" placeholder="Caixa" defaultValue={o.caixa || ''}
                    title="Nº da caixa na expedição (1 a 50)"
                    style={{ width: 64, fontSize: 12.5, padding: '5px 7px' }}
                    onBlur={e => e.target.value !== (o.caixa || '') && salvarCaixa(o.id, e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && e.target.blur()} />
                  {o.perdas > 0 && (
                    <span className="badge" style={{ background: '#fdecec', color: '#b91c1c' }}>
                      Refeita{o.perdas > 1 ? ` ×${o.perdas}` : ''}
                    </span>
                  )}
                  {o.div_pendentes > 0 && (
                    <span className="badge" style={{ background: '#fdecec', color: 'var(--vermelho)' }}>
                      {o.div_pendentes} divergência{o.div_pendentes > 1 ? 's' : ''}
                    </span>
                  )}
                  <span className="badge" style={{ background: ST_COR[o.status] + '22', color: ST_COR[o.status] }}>
                    {ST_LABEL[o.status]}
                  </span>
                  {o.status === 'montagem' && (
                    <button className="btn-sec" style={{ color: '#b91c1c', borderColor: '#b91c1c' }}
                      onClick={() => setPerda({ id: o.id, texto: '' })}>
                      <Icone nome="refazer" size={13} /> Perda na montagem
                    </button>
                  )}
                  {proximo && (podeClicar ? (
                    <button className="btn" style={{ padding: '7px 12px', fontSize: 13 }} onClick={() => avancar(o.id)}>
                      → {ST_LABEL[proximo]}
                    </button>
                  ) : (
                    <span style={{ fontSize: 12, color: 'var(--cinza)', fontStyle: 'italic' }}>
                      Aguardando a loja confirmar o recebimento
                    </span>
                  ))}
                </div>
              </div>
              {perda?.id === o.id && (
                <div style={{ background: '#fdecec', borderRadius: 8, padding: 10, marginTop: 10 }}>
                  <label className="label">O que aconteceu na montagem? (a loja verá esta observação)</label>
                  <textarea className="textarea" rows={2} autoFocus value={perda.texto}
                    onChange={e => setPerda({ ...perda, texto: e.target.value })}
                    placeholder="Ex.: Lente do olho direito arranhou na montagem — refazendo o pedido no laboratório" />
                  <div className="row" style={{ marginTop: 8 }}>
                    <button className="btn" style={{ background: '#b91c1c' }} onClick={registrarPerda}>
                      Registrar perda e voltar p/ Pedido Feito
                    </button>
                    <button className="btn-sec" onClick={() => setPerda(null)}>Cancelar</button>
                  </div>
                </div>
              )}
              <div className="steps" style={{ marginTop: 12 }}>
                {FLUXO.map((s, i) => (
                  <span key={s} title={ST_LABEL[s]}
                    style={{ background: i <= idx ? ST_COR[s] : undefined }} />
                ))}
              </div>
            </div>
          );
        })}
        {!carregando && !abertas.length && (
          <div className="card" style={{ textAlign: 'center', color: 'var(--cinza)' }}>
            Nenhuma OS em andamento.
          </div>
        )}
      </div>
    </div>
  );
}
